import { useEffect, useState } from 'react';
import './Footer.css';

export default function Footer() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <footer className="footer">
        <div className="footer__gradient-bar" />
        <div className="container">
          <div className="footer__academic">
            <a
              href="https://scholar.google.com/citations?user=mYpXeHYAAAAJ&hl=en"
              target="_blank"
              rel="noopener noreferrer me"
              className="footer__scholar"
            >
              Google Scholar
            </a>
            <a
              href="https://orcid.org/0009-0002-5447-9005"
              target="_blank"
              rel="noopener noreferrer me"
              className="footer__scholar"
            >
              ORCID
            </a>
            <a
              href="https://publicpolicy.cornell.edu/people/elijah-moreno/"
              target="_blank"
              rel="noopener noreferrer me"
              className="footer__scholar"
            >
              Cornell Profile
            </a>
          </div>

          <p className="footer__legal">
            &copy; {new Date().getFullYear()} Lumecon Inc. All rights reserved. Built at Cornell University.
          </p>
          <p className="footer__contact">
            <a href="mailto:esm247@cornell.edu">esm247@cornell.edu</a>
          </p>
        </div>
      </footer>

      <button
        className={`back-to-top ${showTop ? 'back-to-top--visible' : ''}`}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        aria-label="Back to top"
      >
        &#8593;
      </button>
    </>
  );
}
